import * as React from 'react';
import { IMissingVoucherConsent } from '@nkr/models/index';

interface IProps {
    data: IMissingVoucherConsent,
    centerId: number
}

class Row extends React.Component<IProps, {}> {
    render = () => {
        return (
            <tr>
                <td><a href={`center/${this.props.centerId}/donor/${this.props.data.donorId}/profile/donor-data`} target='_blank'>{this.props.data.alias}</a></td>
                <td>{this.props.data.donationDate}</td>
                <td>{this.props.data.voucherHoldersMissingConsent}</td>
            </tr>
        )
    }
}

export default Row;